import React, { useEffect } from 'react';

const InsuranceCheckbox = ({ formData, setFormData }) => {
    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        const originalValue = parseFloat(formData.cifValue.value);
        const insuranceValue = originalValue * 0.0075;
        const newValue = isChecked ? insuranceValue : 0;

        // Convert formData.total to a number
        const currentTotal = parseFloat(formData.total);

        // Calculate the new total
        const newTotal = isChecked ? currentTotal + newValue : currentTotal - parseFloat(formData.insurance);

        setFormData((prevFormData) => ({
            ...prevFormData,
            insurance: newValue.toFixed(2),
            isInsuranceChecked: isChecked,
        }));
    };

    // Keep insurance amount in sync on initial load and when CIF/checkbox changes
    useEffect(() => {
        const cif = parseFloat(formData?.cifValue?.value || 0) || 0;
        const expected = formData.isInsuranceChecked ? +(cif * 0.0075).toFixed(2) : 0;
        const current = parseFloat(formData.insurance || 0) || 0;
        if (current !== expected) {
            setFormData((prev) => ({ ...prev, insurance: expected.toFixed(2) }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.isInsuranceChecked, formData?.cifValue?.value]);


    return (
        <div className="flex items-center gap-3 w-full">
            <input
                // checked={formData.insurance === 0 ? false : true}
                checked={formData.isInsuranceChecked}
                type="checkbox"
                onChange={handleCheckboxChange}
            />
            <label
                className="font-normal text-[10px] w-full"
                htmlFor="chkbox"
            >
                Insurance on 0.75% CIF value
            </label>
            <div className="flex md:w-1/2 w-full justify-between">
                <div>
                    <p className="text-[14px]">Insurance Amount:</p>
                </div>
                <div className="">
                    <p className="text-[14px] font-extrabold">
                        {formData.insurance}

                    </p>
                </div>
            </div>
        </div>
    );
};

export default InsuranceCheckbox;
